import { render } from "./BaseNavigation.vue?vue&type=template&id=96802348&scoped=true"
const script = {}

import "./BaseNavigation.vue?vue&type=style&index=0&id=96802348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96802348"]])

export default __exports__